import { useEffect, useState } from 'react';

/*
 * EL TECLADO DEL MÓVIL, ABIERTO O NO.
 *
 * Con el teclado abierto, el iPhone encoge la vista visible y desplaza los
 * elementos fijos; la barra de abajo flotaba encima del teclado y, al cerrarlo, a
 * veces se quedaba más abajo de su sitio. Las apps nativas esconden la barra de
 * pestañas mientras se escribe: aquí igual. Se mide con `visualViewport`, que es
 * lo único que dice de verdad cuánto tapa el teclado.
 */

/** Lo que tapa un teclado de verdad: menos que esto es la barra del navegador moviéndose. */
const UMBRAL_PX = 150;

export function tecladoAbierto(altoVentana: number, altoVisible: number): boolean {
  return altoVentana - altoVisible > UMBRAL_PX;
}

export function useTecladoAbierto(): boolean {
  const [abierto, setAbierto] = useState(false);
  useEffect(() => {
    const vista = window.visualViewport;
    if (!vista) return;
    const medir = () => setAbierto(tecladoAbierto(window.innerHeight, vista.height));
    medir();
    vista.addEventListener('resize', medir);
    return () => vista.removeEventListener('resize', medir);
  }, []);
  return abierto;
}
